import * as React from 'react'

import FeatureContainer from '../../../client/containers/feature'
import ExperimentsLoadingCover from '../../components/experimentsLoadingCover'
import experimentsConfig from '../../../config/experiments'
import copyData from './homePageCopyData'
import ClassicTemplate from './templates/classicTemplate'
import RedesignedTemplate from './templates/redesignedTemplate'
import ContentHeavyTemplate from './templates/contentHeavyTemplate'

import * as styles from './homePage.module.css'

import { Props } from '../../containers/homePageContainer/createHomePageContainer'

const HomePage = ({
  currentSite,
  isSignedIn,
  metadata,
  categories,
  newestItemsData,
  featuredItems,
  freeItems,
  featuredAuthor,
  fetchNewestItemsByCategory,
  preferences,
  muteVideo,
  reportItemClick,
  makeSearchLink,
  experiments,
  experimentsReady
}: Props) => {
  const siteCopyData = copyData[currentSite] || copyData.default
  return (
    <div className={styles.root}>
      <ExperimentsLoadingCover
        currentSite={currentSite}
        experimentsReady={experimentsReady}
        experimentsConfig={experimentsConfig}
      >
        <FeatureContainer name="!homepageNewDesign">
          <ClassicTemplate
            siteCopyData={siteCopyData}
            currentSite={currentSite}
            isSignedIn={isSignedIn}
            metadata={metadata}
            categories={categories}
            newestItemsData={newestItemsData}
            featuredItems={featuredItems}
            freeItems={freeItems}
            featuredAuthor={featuredAuthor}
            fetchNewestItemsByCategory={fetchNewestItemsByCategory}
            preferences={preferences}
            muteVideo={muteVideo}
            reportItemClick={reportItemClick}
            makeSearchLink={makeSearchLink}
            experiments={experiments}
            experimentsReady={experimentsReady}
          />
        </FeatureContainer>
        <FeatureContainer name="homepageNewDesign">
          <FeatureContainer name="homepageContentHeavy">
            <ContentHeavyTemplate
              siteCopyData={siteCopyData}
              currentSite={currentSite}
              isSignedIn={isSignedIn}
              metadata={metadata}
              categories={categories}
              newestItemsData={newestItemsData}
              featuredItems={featuredItems}
              freeItems={freeItems}
              featuredAuthor={featuredAuthor}
              fetchNewestItemsByCategory={fetchNewestItemsByCategory}
              preferences={preferences}
              muteVideo={muteVideo}
              reportItemClick={reportItemClick}
              makeSearchLink={makeSearchLink}
              experiments={experiments}
              experimentsReady={experimentsReady}
            />
          </FeatureContainer>

          <FeatureContainer name="!homepageContentHeavy">
            <RedesignedTemplate
              siteCopyData={siteCopyData}
              currentSite={currentSite}
              isSignedIn={isSignedIn}
              metadata={metadata}
              categories={categories}
              newestItemsData={newestItemsData}
              featuredItems={featuredItems}
              freeItems={freeItems}
              featuredAuthor={featuredAuthor}
              fetchNewestItemsByCategory={fetchNewestItemsByCategory}
              preferences={preferences}
              muteVideo={muteVideo}
              reportItemClick={reportItemClick}
              makeSearchLink={makeSearchLink}
              experiments={experiments}
              experimentsReady={experimentsReady}
            />
          </FeatureContainer>
        </FeatureContainer>
      </ExperimentsLoadingCover>
    </div>
  )
}

export default HomePage
